<nav aria-label="Parcours de mise en ligne propriétaire" class="w-full">
  <ol class="flex items-center w-full">
    @for (step of steps; track step.key; let i = $index; let isLast = $last) {
      @let isCompleted = isStepCompleted(i);
      @let isActive = currentStepIndex() === i;
      @let isAccessible = isStepAccessible(i);
      @let canNavigate = (isCompleted || isActive || isAccessible) && isAccessible;

      <li class="flex items-center" [class.flex-1]="!isLast">
        <a
          [routerLink]="canNavigate && propertyId() ? getStepLink(step.key) : null"
          class="group flex items-center gap-2 rounded-lg py-1 px-2.5 transition-all text-left"
          [class.bg-primary-2]="isActive"
          [class.hover:bg-gray-3]="canNavigate && !isActive"
          [class.cursor-pointer]="canNavigate && !isActive"
          [class.cursor-default]="isActive"
          [class.cursor-not-allowed]="!isAccessible"
          [class.opacity-40]="!isAccessible"
          [attr.aria-disabled]="!isAccessible"
        >
          <!-- Step indicator dot/icon -->
          <div
            class="flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[10px] font-bold transition-all"
            [class.bg-primary-9]="isActive"
            [class.text-white]="isActive || isCompleted"
            [class.bg-jade-9]="isCompleted && !isActive"
            [class.bg-gray-4]="isAccessible && !isActive && !isCompleted"
            [class.text-gray-11]="isAccessible && !isActive && !isCompleted"
            [class.bg-gray-3]="!isAccessible"
            [class.text-gray-8]="!isAccessible"
            [class.border]="!isAccessible"
            [class.border-gray-5]="!isAccessible"
          >
            @if (isCompleted && !isActive) {
              <mat-icon class="text-[12px]! w-3 h-3 flex items-center justify-center text-white"
                >check</mat-icon
              >
            } @else {
              <span>{{ i + 1 }}</span>
            }
          </div>

          <!-- Step label -->
          <div class="flex items-center gap-1.5 whitespace-nowrap">
            <span
              class="text-xs transition-colors"
              [class.font-bold]="isActive"
              [class.text-primary-11]="isActive"
              [class.font-semibold]="isCompleted && !isActive"
              [class.text-gray-12]="isCompleted && !isActive"
              [class.font-medium]="!isCompleted && !isActive"
              [class.text-gray-11]="isAccessible && !isCompleted && !isActive"
              [class.text-gray-8]="!isAccessible"
            >
              {{ step.label }}
            </span>

            @if (step.isOptional) {
              <span
                class="hidden sm:inline-block rounded px-1.5 py-0.2 text-[9px] font-medium transition-colors"
                [class.bg-gray-4]="isAccessible"
                [class.text-gray-10]="isAccessible"
                [class.bg-gray-3]="!isAccessible"
                [class.text-gray-8]="!isAccessible"
              >
                Facultatif
              </span>
            }
          </div>
        </a>

        <!-- Connecting Line Segment -->
        @if (!isLast) {
          <div
            class="flex-1 mx-2 sm:mx-4 h-[2px] rounded-full transition-colors"
            [class.bg-primary-9]="isStepCompleted(i)"
            [class.bg-gray-4]="!isStepCompleted(i)"
          ></div>
        }
      </li>
    }
  </ol>
</nav>
